<p-dialog header="{{savedSearchAddViewEditHeader}}" [(visible)]="displayAddEditDialog" [style]="{ width: '60vw' }" (onHide)="closeDialog()" [closable]="false" [modal]="true" [responsive]="true">

    <app-subscription-limit-message
        *ngIf="subscriptionLimitReached"
        [subscriptionLimit]="subscriptionLimit"
        [moduleName]="'Saved Search'">
    </app-subscription-limit-message>

    <form *ngIf="!subscriptionLimitReached" [formGroup]="savedSearchDetailsForm" novalidate>
        <div class="header">
            <h5>Search Information
                <p-inputSwitch formControlName="isActive" class="header-switch" [disabled]="savedSearchViewOnly"></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Saved Search Name <span style="color: red;">*</span></label>
                    <input type="text" pInputText formControlName="name">

                    <div *ngIf="detailsFormErrors?.name" class="p-invalid">
                        <small>{{ detailsFormErrors?.name }}</small>
                    </div>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Access Permission</label>
                    <liono-treeSelect [disabled]="savedSearchViewOnly"
                        formControlName="selectedUsers"
                        [options]="activeUserTree"
                        [selectionMode]="'multiple'"
                        [metaKeySelection]="false"
                        [filter]="true"
                        [filterBy]="'name'"
                        filterPlaceholder="Search Users..."
                        appendTo="body" placeholder="Select Users"
                        (onNodeSelect)="onUserSelect($event)">
                        <ng-template let-value pTemplate="selectedItems">
                            <span *ngFor="let selectedCUser of (savedSearchDetailsForm.value.selectedUsers||[]); let i = index">
                                {{ (i>0 && i<10)? ',':'' }} {{i<10?selectedCUser?.name: (i==10?'...':'')}}
                            </span>

                            <div *ngIf="!savedSearchDetailsForm.value.selectedUsers || savedSearchDetailsForm.value.selectedUsers?.length === 0">
                                Select Users
                            </div>
                         </ng-template>
                    </liono-treeSelect>

                    <div *ngIf="detailsFormErrors?.selectedUsers" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedUsers }}</small>
                    </div>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-6">
                    <label>Module <span style="color: red;">*</span></label>
                    <p-dropdown appendTo="body" [options]="parentModules" formControlName="selectedModule"
                        optionLabel="name" dataKey="id" placeholder="Select Module" [filter]="true"
                        [resetFilterOnHide]="true" (onChange)="onChangeParentModule()"
                        [disabled]="savedSearchViewOnly || savedSearchEditId !== null">
                    </p-dropdown>

                    <div *ngIf="detailsFormErrors?.selectedModule" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedModule }}</small>
                    </div>
                </div>
                <div class="p-col-5">
                    <ng-container *ngIf="![activityModuleId,taskModuleId,vendorModuleId,locationModuleId].includes(savedSearchDetailsForm.value.selectedModule?.objectId)">
                        <label>Channel <span style="color: red;">*</span></label>
                        <p-dropdown appendTo="body" [options]="parentTemplates" formControlName="selectedChannel"
                            optionLabel="channelName" dataKey="id" placeholder="Select Channel" [filter]="true"
                            [resetFilterOnHide]="true" (onChange)="onChangeParentChannel()"
                            [disabled]="savedSearchViewOnly   || savedSearchEditId !== null">
                        </p-dropdown>

                        <div *ngIf="detailsFormErrors?.selectedChannel" class="p-invalid">
                            <small>{{ detailsFormErrors?.selectedChannel }}</small>
                        </div>
                    </ng-container>
                </div>
                <div [ngClass]="{'saved-search-disabled': savedSearchViewOnly}" class="p-col-1 p-mt-5 p-text-right" *ngIf="savedSearchDetailsForm.value.selectedChannel && (accountChannelsFor.includes(savedSearchDetailsForm.value.selectedModule?.name) ? (savedSearchDetailsForm.value?.selectedAccountChannel?.id > 0) : true)"
                    pTooltip="Add Parent Rule" tooltipPosition="top">
                    <p-button [disabled]="savedSearchViewOnly" icon="pi pi-plus" (click)="newParentRule()">
                    </p-button>
                </div>
                <div class="p-col-6"
                    [hidden]="!accountChannelsFor.includes(savedSearchDetailsForm.value.selectedModule?.name)">
                    <label>Account Channel <span style="color: red;">*</span></label>
                    <p-dropdown appendTo="body" [options]="accountChannelsIsActive"
                        formControlName="selectedAccountChannel" optionLabel="name" dataKey="id"
                        placeholder="Select Account Channel" [filter]="true" [resetFilterOnHide]="true" [disabled]="savedSearchViewOnly " (onChange)="changeAccountChannel()" >
                    </p-dropdown>
                    <!-- (onChange)="getChannelListAfterAccountChannel()" -->

                    <div *ngIf="detailsFormErrors?.selectedAccountChannel" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedAccountChannel }}</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="header p-d-flex p-jc-between" *ngIf="ruleData.length > 0 && savedSearchDetailsForm.value.selectedModule?.childobject?.length > 0">
            <h5 class="p-mt-2">{{savedSearchDetailsForm.value.selectedModule?.name}} Dependent Module</h5>
            <div [ngClass]="{'saved-search-disabled': savedSearchViewOnly}" class="btnBars p-mr-0" (click)="addAssociateModule()" pTooltip="Add Dependent Module" tooltipPosition="top">
                <i class="pi pi-plus"></i>
            </div>
        </div>
        <div class="card" *ngIf="ruleData.length > 0">
            <div class="p-field p-grid">
                <div class="p-col-12">
                    <app-saved-search-added-rules-table
                        [isDisabled]="savedSearchViewOnly"
                        [ruleData]="ruleData"
                        [ruleCombination]="ruleCombination"
                        [isCombinational]="isCombinational"
                        [editedRuleData]="editedRuleData"
                        (saveRuleCombination)="saveRuleCombination($event)"
                        (updateRuleChoice)="updateRuleChoice($event)"
                        (editRuleChange)="editRule($event)"
                        (removeRuleChange)="removeRule($event)">
                    </app-saved-search-added-rules-table>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button *ngIf="!subscriptionLimitReached" type="button" [disabled]="!ruleData?.length || savedSearchViewOnly || savedSearchDetailsForm.invalid" pButton (click)="openPreviewSavedSearch()" label="Preview">
        </button>
        <button type="button" pButton (click)="closeDialog()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!subscriptionLimitReached" type="submit" [disabled]="!ruleData?.length || savedSearchViewOnly || savedSearchDetailsForm.invalid" pButton (click)="saveSavedSearch('Save')" label="Save">
        </button>
    </p-footer>
</p-dialog>

<!-- Rule Parent Add -->
<p-dialog header="Add Parent Rules" [(visible)]="displayParentNewRule"  [modal]="true" [closable]="false" [responsive]="true" [style]="{width: '55vw'}">
    <div class="card">
        <div class="card" *ngIf="parentRulesLength">
            <div class="p-field p-grid">
                <div class="p-col-12">
                    <app-saved-search-added-rules-table
                        [isDisabled]="savedSearchViewOnly"
                        [ruleData]="ruleData"
                        [ruleCombination]="ruleCombination"
                        [showHideDefaultData]="showHideDefaultData"
                        [isCombinational]="isCombinational"
                        [editedRuleData]="editedRuleData"
                        (saveRuleCombination)="saveRuleCombination($event)"
                        (updateRuleChoice)="updateRuleChoice($event)"
                        (editRuleChange)="editRule($event)"
                        (removeRuleChange)="removeRule($event)"
                        [isMainModule]="true">
                    </app-saved-search-added-rules-table>
                </div>
            </div>
        </div>
        <app-saved-search-main-module-rules-selection
            [displayRules]="displayParentNewRule"
            [selectedParentModule]="selectedModule"
            [selectedParentTemplate]="selectedTemplate"
            [selectedAccountChannel]="savedSearchDetailsForm.value.selectedAccountChannel"
            [selectedAssoModule]="selectedAssoModule"
            [selectedAssoTemplate]="selectedAssoTemplate"
            [isMainModule]="true"
            [ruleData]="ruleData"
            [ruleList]="ruleList"
            [lastRuleValues]="lastRuleValues"
        ></app-saved-search-main-module-rules-selection>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancelParentRuleDialog()" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="saveRule(true)"></button>
    </p-footer>
</p-dialog>

<!-- Associate Rule Add -->
<p-dialog header="Add Dependent Module Rules" [(visible)]="displayAssociateRule"  [modal]="true" [closable]="false" [responsive]="true" [style]="{width: '55vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Associated Module <span style="color: red;">*</span></label>
                <p-dropdown appendTo="body" [options]="assoModules" [(ngModel)]="selectedAssoModule" (onChange)="selectAssociateModule()" optionLabel="name" id="parentModules" dataKey="id" placeholder="Associated with">
                </p-dropdown>
            </div>
            <!-- <div class="p-col-6">
                <label>Template <span class="required-field">*</span></label>
                <p-dropdown appendTo="body" [options]="assoTemplates" [(ngModel)]="selectedAssoTemplate" (onChange)="selectAssociateChannel()" optionLabel="templateName" dataKey="id" placeholder="Select Template">
                </p-dropdown>
            </div> -->
        </div>
        <div class="card" *ngIf="associateRulesLength && showHideDefaultData">
            <div class="p-field p-grid">
                <div class="p-col-12">
                    <app-saved-search-added-rules-table
                        [isDisabled]="savedSearchViewOnly"
                        [ruleData]="ruleData"
                        [ruleCombination]="ruleCombination"
                        [showHideDefaultData]="showHideDefaultData"
                        [isCombinational]="isCombinational"
                        [editedRuleData]="editedRuleData"
                        [isMainModule]="false"
                        (saveRuleCombination)="saveRuleCombination($event)"
                        (updateRuleChoice)="updateRuleChoice($event)"
                        (editRuleChange)="editRule($event)"
                        (removeRuleChange)="removeRule($event)">
                    </app-saved-search-added-rules-table>
                </div>
            </div>
        </div>

        <app-saved-search-main-module-rules-selection
            *ngIf="selectedAssoModule"
            [selectedParentModule]="selectedModule"
            [selectedParentTemplate]="selectedTemplate"
            [selectedAccountChannel]="savedSearchDetailsForm.value.selectedAccountChannel"
            [selectedAssoModule]="selectedAssoModule"
            [selectedAssoTemplate]="selectedAssoTemplate"
            [isMainModule]="false"
            [ruleData]="ruleData"
            [ruleList]="assocRuleList"
            [lastRuleValues]="lastAssocRuleValues"
        ></app-saved-search-main-module-rules-selection>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancelParentRuleDialog()" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="saveRule(false)" [disabled]="!selectedAssoModule"></button>
    </p-footer>
</p-dialog>

<!-- Rule Edit -->
<p-dialog header="Edit Rule" [(visible)]="displayEditRule"  [modal]="true" [closable]="false" [responsive]="true" [style]="{width: '55vw'}">
    <div class="card">
        <app-saved-search-main-module-rules-selection
            [selectedParentModule]="selectedModule"
            [selectedParentTemplate]="selectedTemplate"
            [selectedAccountChannel]="savedSearchDetailsForm.value.selectedAccountChannel"
            [selectedAssoModule]="selectedAssoModule"
            [selectedAssoTemplate]="selectedAssoTemplate"
            [isMainModule]="true"
            [ruleData]="ruleData"
            [ruleList]="ruleList"
            [lastRuleValues]="selectedEditedRule?.isMainModule ? lastRuleValues : lastAssocRuleValues"
            [editRule]="true"
            [selectedRule]="selectedEditedRule"
        ></app-saved-search-main-module-rules-selection>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancelEditRule()" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="updateEditedRule()"></button>
    </p-footer>
</p-dialog>

<!-- Preview Data List -->
<app-saved-search-preview-modal *ngIf="displaySSPreviewDataList" [displayPreviewDataList]="displaySSPreviewDataList" [previewDataList]="ssPreviewDataList" [previewColumnList]="ssPreviewColumnList" (onPreviewCancel)="onSSPreviewCancel()">
</app-saved-search-preview-modal>
